import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Flex, Text, Image, SquareProps, Card, SemanticToken } from '@chakra-ui/react';
import { ICustomer } from '../../../../interfaces/jobsheets/ICustomer';
import * as webHelpers from "../../../../helpers/WebHelpers";
import AcceptedCardImage from "../../../../assets/cards.png";
import AcceptedCardImage2 from "../../../../assets/card_image5.png";
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import { Payment } from 'square';
import { Card as CardObject } from 'square'; //name Card is already used so importerd as CardObject
//import { TokenResult } from 'square'; 
import { Client, Environment, ApiError } from 'square';
import SquareTokenizeForm from '../tokenize';

interface ISquareProps {
    amount: number
    billingContact: ICustomer | null
    customerId: string //This is the square_card_identifier
    sci: string
    callback: () => void
}

const square = window.Square;

export default function SquarePaymentFormExisting(props: ISquareProps) {
    const amount = useRef(props.amount);
    const sendDataToGTM = useGTMDispatch();
    const [previousPayment, setPreviousPayment] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [isInProgress, setIsInProgress] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [customerId, setCustomerId] = useState<string>(props.customerId);
    const [cardId, setCardId] = useState<string>(props.sci);

    const appId = "sq0idp-hYkN_vRN7_Q8QsQpwVSPhw";
    //const appId = 'sandbox-sq0idb-yCbXhfB7FMW6DfrrTQUvKw'; //Sandbox
    const locationId = "LV18QEZ0BJXWP";
    //const locationId = 'LVW97TX91JNEG'; //Sandbox

    //used to be a ts-ignore here
    async function initializeCard(payments: Payment): Promise<CardObject> { //used to import payments object
        const card = await square.payments(appId, locationId).card();

        //Get rid of any old card containers
        const elm = document.getElementById('card-container');
        if (elm) {
            elm.innerHTML = "";
        }

        await card.attach("#card-container");
        console.log("card to be returned is ", card);
        return card;
    }
    // SOURCEID = TOKEN, locationId blank for now, 
    // verificationToken can be undefined, as it does not apply to all payment methods.
    //used to be a ts-ignore here 
    //@ts-ignore
    async function createPaymentWithCardOnFile(sourceId, verification_token, customer_id) {
        console.log("Taking payment" + amount.current);
        const bodyParameters = {
            amount: amount.current,
            name: props.billingContact?.Billing.Contact.LastName,
            locationId,
            sourceId: sourceId,
            customerId: customer_id,
            verification_token: verification_token,
        };

        const body = JSON.stringify(bodyParameters);
        let response = await webHelpers.postAsync("/api/payment/take/existing", bodyParameters);
        //let response = await webHelpers.postAsync("/api/verify/card/details", bodyParameters);
    }

    // status is either SUCCESS or FAILURE;
    //used to be a ts-ignore here
    function displayPaymentResults(status: string) {
        if (status === "SUCCESS") {
            setIsError(false);
            setIsSuccess(true);
        } else {
            setIsSuccess(false);
            setIsError(true);
            setErrorMsg("Payment unsuccessful")
        }

        setIsInProgress(false);
    }

    //used to be a ts ignore here
    async function verifyBuyer(payments: any, token: string) {
        console.log(amount.current);
        console.log(props.billingContact?.Billing);
        const verificationDetails = {
            amount: amount.current.toString(),
            billingContact: {
                addressLines: [
                    props.billingContact?.Billing.Address.line1 ?? "",
                    props.billingContact?.Billing.Address.line2 ?? "",
                    props.billingContact?.Billing.Address.line3 ?? "",
                    props.billingContact?.Billing.Address.line4 ?? "",
                    props.billingContact?.Billing.Address.post_code ?? ""
                ],
                familyName: props.billingContact?.Billing.Contact.LastName,
                givenName: props.billingContact?.Billing.Contact.FirstName,
                email: props.billingContact?.Billing.Contact.EmailAddress,
                phone: props.billingContact?.Billing.Contact.MobileNumber == undefined ? props.billingContact?.Billing.Contact.LandLine : props.billingContact?.Billing.Contact.MobileNumber
            },
            currencyCode: "GBP",
            intent: "CHARGE",
        };

        const verificationResults = await payments.verifyBuyer(
            token,
            verificationDetails
        );
        return verificationResults.token;
    }

    async function buildForm() {
        if (!square) {
            throw new Error("Square.js failed to load properly");
        }
        let payments: Payment;
        let card: CardObject;

        try {
            //used to be a ts-ignore here 
            payments = square.payments(appId, locationId); //appId = the appId of square developer application, found in square developer dashboard
            //const payments2 = Square.payments(appId,locationId);
            //locationId = ID of the seller location where the payment is taken, is required to accept Apple Pay, Google Pay, ACH and Cash App payments
            console.log("payments = ", (payments));
            if (payments !== null) {
                try {
                    card = await initializeCard(payments); //used to use payments as a parameter
                } catch (e) {
                    console.error("Initializing Card failed", e);
                }
            }
        } catch { //if the program can't create a proper payment then this code will let the user know
            const statusContainer = document.getElementById("payment-status-container");
            if (statusContainer?.className != null) {
                (statusContainer.className) = "missing-credentials";
            }
            if (statusContainer?.style.visibility != null) {
                statusContainer.style.visibility = "visible";
            }
        }



        async function handlePaymentMethodWithCardOnFileMethodSubmission(
            event: MouseEvent,
            paymentMethod: any,
            customerId: string,
        ) {
            event.preventDefault();
            setIsError(false);
            setIsSuccess(false);
            setIsInProgress(true);

            try {
                
                // disable the submit button as we await tokenization and make a payment request.
                //used to be  a ts ignore here
                if (cardButton != null) {
                    ((cardButton) as HTMLButtonElement).disabled = true;
                    //(document.getElementById('BenchForcastId_'+cardButton) as HTMLButtonElement).disabled = true;
                }

                console.log(paymentMethod, customerId);
                let verificationToken: string;

                //used to be a ts ignore here 
                verificationToken = await verifyBuyer(payments, cardId);
                console.log("verif token", verificationToken);
                await createPaymentWithCardOnFile(cardId, verificationToken, customerId);
                console.log("errors here : ");
                setPreviousPayment(amount.current);
                console.log("success");
                displayPaymentResults("SUCCESS");

                if (cardButton != null) {
                    ((cardButton) as HTMLButtonElement).disabled = false;
                }
                sendDataToGTM({ event: "payment_success", paymentValue: amount.current });
                //console.debug("Payment Success", paymentResults);
                console.log("Payment success");
                props.callback();
            
            } 
            catch (e) {
                if (cardButton != null) {
                    ((cardButton) as HTMLButtonElement).disabled = false;
                }
                console.log("Payment failure");
                sendDataToGTM({ event: "payment_failed", paymentValue: amount.current });
                displayPaymentResults("FAILURE");
                //console.error(e.message);
            }
        }

        const cardButton = document.getElementById("card-button");
        if (cardButton != null)
            cardButton.addEventListener("click", async function (event) {
                // SCA only needs to be run for Card Payments. All other payment methods can be set to false.
                handlePaymentMethodWithCardOnFileMethodSubmission(event, cardId, customerId);
            });
        // });
    }


    useEffect(() => {
        if (!loading) {
            console.log("loading");
            setLoading(true);
        }
    }, [loading]);

    useEffect(() => {
        amount.current = props.amount;
        console.log("Square Amount changed " + props.amount);
    }, [props.amount])

    return (
        <>
            <Flex direction='column' alignItems='center' w='full' mt={4}>

                <Flex direction='row' justify='center'>
                    <form id="payment-form" className="flex justify-center flex-col">
                        <Box paddingTop={"4%"}>
                            <Image src={AcceptedCardImage2} alt='Accepted payment methods' w={200} mb={2} paddingBottom={"1%"} /> {/* was w=294*/}
                        </Box>
                        <Button colorScheme={"blue"} id="card-button" type="submit" disabled={Number.isNaN(props.amount) || props.amount < 0.01 || props.billingContact === null} marginTop={"10%"} marginBottom={"2%"}
                            isLoading={isInProgress} loadingText="Submitting  " spinnerPlacement='end' w='full'>
                            Pay £{props.amount.toFixed(2)}
                        </Button>
                    </form>
                </Flex>

            </Flex>
            <Flex direction='column' justify='center' mt={4}>
                {isSuccess &&
                    <Alert status='success'>
                        <AlertIcon />
                        <Box>
                            <AlertTitle>Payment Successful</AlertTitle>
                            <AlertDescription>You made a payment of £{previousPayment.toFixed(2)}</AlertDescription>
                        </Box>
                    </Alert>
                }
                {isError &&
                    <Alert status='error'>
                        <AlertIcon />
                        <Box>
                            <AlertTitle>{errorMsg}</AlertTitle>
                            <AlertDescription>Check your details and try again, or contact us for further help.</AlertDescription>
                        </Box>
                    </Alert>
                }
            </Flex>
        </>
    )
}